
import axios from './request'

const URL = {
  // 我的账户
  MyAccount: {
    // 账户列表
    // MyAccount: '/FINANCEBASEINFO-SERVER/subsidiaryAccountApp/getMySubsidiaryList.magpie',
    // MyAccount: '/PLATFORM-ACCOUNT-SERVER/platformBaseAccount/appList.magpie',
    MyAccount: '/FUND-ACCOUNT-SERVICE/fund/account/querylist.magpie',
    // 详情
    myAccountDetail: '/PLATFORM-ACCOUNT-SERVER/platformBaseAccount/baseAccountDetail.magpie',
    // 校验支付密码
    checkPay: '/USER-SERVER/facade/checkPay.magpie',
    // 设置支付密码
    setPayPwd: '/USER-SERVER/appuser/setPayPwd.magpie',
    // 修改支付密码
    modifyPayPwd: '/USER-SERVER/appuser/editPayPwd.magpie',
    // 发送验证码
    sendOutCode: '/USER-SERVER/appuser/smsCode.magpie',
    // 验证码校验接口
    checkCode: '/USER-SERVER/appuser/checkCode.magpie',
    // 转账/提现申请
    applyTransferOrWithdraw: '/DISCREPANCY-GOLD-SERVER/discrepancyGold/apply.magpie',
  },
  // 京东充值
  JDTopUp: {
    // 充值管理列表
    fetchList: '/PLATFORM-ACCOUNT-SERVER/accountRechargeRecord/clientList.magpie',
    // 京东企业账户充值
    enterpriseTopUp: '/DISCREPANCY-GOLD-SERVER/subsidiaryRamify/applyRecharge.magpie',
    // 用户Id和渠道号查附属账户信息
    getAccountInfo: '/FINANCEBASEINFO-SERVER/subsidiaryAccount/queryAccountDetailByUserId.magpie',
  },
  JDPayment: {
    // 支付列表
    fetchList: '/TRADE-DELIVERY-SERVER/tradePayInfoController/clientList.magpie',
    // 支付
    pay: '/TRADE-DELIVERY-SERVER/tradePayInfoController/beginPayAcquire.magpie',
    // 详情
    detail: '/TRADE-DELIVERY-SERVER/tradePayInfoController/detail.magpie',
  },
  // 众邦
  ZBBank: {
    // 转账列表
    transferList: '/DISCREPANCY-GOLD-SERVER/discrepancyGold/transferList.magpie',
    // 转账详情
    transferInfo: '/DISCREPANCY-GOLD-SERVER/discrepancyGold/transferInfo.magpie',
    // 附属账户详细信息
    getMySubAccountDetail: '/FINANCEBASEINFO-SERVER/subsidiaryAccountApp/getMySubAccountDetail.magpie',
    // 最近交易30转账记录
    recentTradeAccount: '/DISCREPANCY-GOLD-SERVER/discrepancyGold/recentTradeAccount.magpie',
    // 判断是否设置了支付密码
    checkHasPsw: '/USER-SERVER/facade/hasPay.magpie',
    // 发送短信信息接口
    sendMsg: '/SMS-SERVICE/sms/sendSms.magpie',
    // 设置支付密码
    setPaymentPass: '/USER-SERVER/appuser/payPwd.magpie',
    // 提现列表
    withdrawList: '/DISCREPANCY-GOLD-SERVER/discrepancyGold/withdrawList.magpie',
    // 提现详情
    getWithdrawRecordsDetail: '/DISCREPANCY-GOLD-SERVER/discrepancyGold/withdrawInfo.magpie',
    // 充值列表
    rechargeList: '/PLATFORM-ACCOUNT-SERVER/accountRechargeRecord/clientList.magpie',
    // 交易流水-> 废弃
    tradingFlowList: '/DISCREPANCY-GOLD-SERVER/discrepancyGold/clientTradeFlowList.magpie',
    // 交易流水
    billList: '/SETTLE-FACADE-SERVER/bill/list.magpie',
    // 获取交易编码
    downloadReceipt: '/SETTLE-FACADE-SERVER/bill/downloadReceipt.magpie',
    // 查询余额
    baseAccountBalance: '/PLATFORM-ACCOUNT-SERVER/platformBaseAccount/baseAccountBalance.magpie',
    // 通过虚拟账户编码查询平台账户
    queryPlatformAccountByExAccountNo: '/PLATFORM-ACCOUNT-SERVER/platformBaseAccount/queryPlatformAccountByExAccountNo.magpie'
  },
  // 诚意金
  CYJAccount: {
    // 诚意金账户列表
    cyjAccountlist: '/PLATFORM-ACCOUNT-SERVER/hs/queryFundAccountInfo.magpie',
    // 诚意金详情
    cyjDetail: '/PLATFORM-ACCOUNT-SERVER/hs/querySettAccountDetail.magpie',
    // 查询市场编码
    getMarketInfoList: '/PLATFORM-ACCOUNT-SERVER/hs/getMarketInfoList.magpie',
    // 银行诚意金出金
    outAccountFund: '/CONTINUTIY-SERVICE/uchps/outAccountFund.magpie',
    // 银行诚意金入金
    intoAccountFund: '/CONTINUTIY-SERVICE/uchps/intoAccountFund.magpie'
  },
  // 货款
  HKAccount: {
    // 货款列表
    // hkList: '/PLATFORM-ACCOUNT-SERVER/goodsPay/selGoodsList.magpie',
    hkList: '/CT-REPORT-SERVER/ucfund/queryUserGoodsFlow.magpie',
    // 货款出入金 - 白糖
    loanInAndOut: '/CONTINUTIY-SERVICE/goodsPay/loanInAndOut.magpie',
    // 货款出入金 - 茧丝
    JSloanInAndOut: '/DISCREPANCY-GOLD-SERVER/cashInAndOut/apply.magpie',
    // 货款余额查询
    queryErpGoodsAccountInfo: '/PLATFORM-ACCOUNT-SERVER/erp/queryErpGoodsAccountInfo.magpie',
    // 查询银行附属账户信息-转入
    querySubBankAccountInfo: '/CONTINUTIY-SERVICE/uchps/querySubBankAccountInfo.magpie',
    // 查询银行附属账户余额-转入
    querySubBankAccountBalance: '/CONTINUTIY-SERVICE/uchps/querySubBankAccountBalance.magpie',
    // 结算账号查询-出金
    fundInInit: '/CONTINUTIY-SERVICE/uchps/fundInInit.magpie',
    // 查询银行入金附属账户及余额-出金
    querySettleAccountMoney: '/CONTINUTIY-SERVICE/uchps/querySettleAccountMoney.magpie',
    // 货款账户列表
    goodsAccountAppList: '/PLATFORM-ACCOUNT-SERVER/goodsAccountApp/page.magpie',
    // 获取货款信息列表
    queryGoodsAccountInfo: '/CT-REPORT-SERVER/common/queryGoodsAccountInfo.magpie'
  },
  // 查询银行流水
  ZXAccount: {
    querySubFlow: '/CONTINUTIY-SERVICE/uchps/querySubFlow.magpie'
  },
  // 保证金账户
  BZJAccount: {
    queryBZJAccount: '/CENTER-DATA-SERVER/fundAccount/findUcFund.magpie', // 查询保证金账户
    flowList: '/CENTER-DATA-SERVER/payment/findUcFundFlow.magpie', // 资金流水
    bzjCash: '/CENTER-DATA-SERVER/payment/fundUcApply.magpie', // 提现接口
  }
}
// 我的账户
class MyAccount {
  /**
   * 列表
   * @param {object} params
   */
  fetchList (params) {
    const url = URL.JDTopUp.fetchList

    return axios.post(url, params)
  }

  /**
   * 京东企业账户充值
   * @param {object} params
   */
  enterpriseTopUp (params) {
    const url = URL.JDTopUp.enterpriseTopUp

    return axios.post(url, params)
  }

  /**
   * 用户Id和渠道号查附属账户信息
   * @param {object} params
   */
  getAccountInfo (params) {
    const url = URL.JDTopUp.getAccountInfo

    return axios.post(url, params)
  }

  /**
   * 支付列表
   * @param {object} params
   */
  fetchPaymentList (params) {
    const url = URL.JDPayment.fetchList

    return axios.post(url, params)
  }

  /**
   * 支付
   */
  toPay (params) {
    const url = URL.JDPayment.pay

    return axios.post(url, params)
  }

  /**
   * 支付
   */
  paymentDetail (params) {
    const url = URL.JDPayment.detail

    return axios.post(url, params)
  }

  /**
   * 众邦转账管理列表
   * @param {object} params
   */
  zbManageList (params) {
    const url = URL.ZBBank.transferList
    return axios.post(url, params)
  }

  /**
   * 众邦转账详情
   * @param {object} params
   */
  zbTransferDetail (params) {
    const url = URL.ZBBank.transferInfo
    return axios.post(url, params)
  }

  /**
   * 我的账户列表
   * @param {object} params
   */
  zbAccountList (params) {
    const url = URL.MyAccount.MyAccount
    return axios.post(url, params)
  }

  /**
   * 我的账户详情
   * @param {object} params
   */
  getMySubAccountDetail (params) {
    const url = URL.ZBBank.getMySubAccountDetail
    return axios.post(url, params)
  }

  /**
   * 业务申请发起提现/转账
   * @param {object} params
   */
  applyTransferOrWithdraw (params) {
    const url = URL.MyAccount.applyTransferOrWithdraw
    return axios.post(url, params)
  }

  /**
   * 对方最近30天转账记录信息
   */
  recentTradeAccount (param) {
    const url = URL.ZBBank.recentTradeAccount
    return axios.post(url, param)
  }

  /**
   * 判断是否已设置支付密码
   */
  checkHasPsw (param) {
    const url = URL.ZBBank.checkHasPsw
    return axios.post(url, param)
  }

  /**
   * 发送短信
   */
  sendMsg (param) {
    const url = URL.ZBBank.sendMsg
    return axios.post(url, param)
  }

  /**
   * 提现列表
   */
  withdrawList (param) {
    const url = URL.ZBBank.withdrawList
    return axios.post(url, param)
  }

  /**
   * 提现详情
   */
  getWithdrawRecordsDetail (param) {
    const url = URL.ZBBank.getWithdrawRecordsDetail
    return axios.post(url, param)
  }

  /**
   * 我的账户详情
   */
  myAccountDetail (param) {
    const url = URL.MyAccount.myAccountDetail
    return axios.post(url, param)
  }

  /**
   * 充值列表
   */
  rechargeList (param) {
    const url = URL.ZBBank.rechargeList
    return axios.post(url, param)
  }

  /**
   * 校验支付密码
   */
  checkPay (param) {
    const url = URL.MyAccount.checkPay
    return axios.post(url, param)
  }

  /**
   * 设置支付密码
   */
  setPayPwd (param) {
    const url = URL.MyAccount.setPayPwd
    return axios.post(url, param)
  }

  /**
   * 获取验证码
   */
  sendOutCode (param) {
    const url = URL.MyAccount.sendOutCode
    return axios.post(url, param)
  }

  /**
   * 验证码校验接口
   */
  checkCode (param) {
    const url = URL.MyAccount.checkCode
    return axios.post(url, param)
  }

  /**
   * 修改支付密码
   */
  modifyPayPwd (param) {
    const url = URL.MyAccount.modifyPayPwd
    return axios.post(url, param)
  }

  /**
   * 诚意金账户列表
   */
  CYJAccount (param) {
    const url = URL.CYJAccount.cyjAccountlist
    return axios.post(url, param)
  }

  /**
   * 诚意金账户列表
   */
  getMarketInfo (param) {
    const url = URL.CYJAccount.getMarketInfoList
    return axios.post(url, param)
  }

  /**
   * 诚意金账户列表
   */
  cyjDetail (param) {
    const url = URL.CYJAccount.cyjDetail
    return axios.post(url, param)
  }

  /**
   * 货款列表
   */
  hkList (param) {
    const url = URL.HKAccount.hkList
    return axios.post(url, param)
  }

  /**
   * 货款出入金 - 白糖
   */
  loanInAndOut (param) {
    const url = URL.HKAccount.loanInAndOut
    return axios.post(url, param)
  }

  /**
   * 货款出入金 - 茧丝
   */
  JSloanInAndOut (param) {
    const url = URL.HKAccount.JSloanInAndOut
    return axios.post(url, param)
  }

  /**
   * 货款余额查询
   */
  queryErpGoodsAccountInfo (param) {
    const url = URL.HKAccount.queryErpGoodsAccountInfo
    return axios.post(url, param)
  }

  /**
   * 查询银行附属账户信息
   */
  querySubBankAccountInfo (param) {
    const url = URL.HKAccount.querySubBankAccountInfo
    return axios.post(url, param)
  }

  /**
   * 查询银行附属账户余额
   */
  querySubBankAccountBalance (param) {
    const url = URL.HKAccount.querySubBankAccountBalance
    return axios.post(url, param)
  }

  /**
   * 结算账号查询-出金
   */
  fundInInit (param) {
    const url = URL.HKAccount.fundInInit
    return axios.post(url, param)
  }

  /**
   * 查询银行入金附属账户及余额-出金
   */
  querySettleAccountMoney (param) {
    const url = URL.HKAccount.querySettleAccountMoney
    return axios.post(url, param)
  }

  /**
   * 货款账户列表
   */
  goodsAccountAppList (param) {
    const url = URL.HKAccount.goodsAccountAppList
    return axios.post(url, param)
  }

  /**
   * 货款信息列表
   */
  queryGoodsAccountInfo (param) {
    const url = URL.HKAccount.queryGoodsAccountInfo
    return axios.post(url, param)
  }

  /**
   * 银行诚意金出金
   */
  outAccountFund (param) {
    const url = URL.CYJAccount.outAccountFund
    return axios.post(url, param)
  }

  /**
   * 银行诚意金入金
   */
  intoAccountFund (param) {
    const url = URL.CYJAccount.intoAccountFund
    return axios.post(url, param)
  }

  /**
   * 查询银行流水
   */
  querySubFlow (param) {
    const url = URL.ZXAccount.querySubFlow
    return axios.post(url, param)
  }

  /**
   * 交易流水
   */
  tradingFlowList (param) {
    const url = URL.ZBBank.tradingFlowList
    return axios.post(url, param)
  }

  /**
   * 电子回单列表
   */
  billList (param) {
    const url = URL.ZBBank.billList
    return axios.post(url, param)
  }

  /**
   * 获取交易编码
   */
  downloadReceipt (param) {
    const url = URL.ZBBank.downloadReceipt
    return axios.post(url, param)
  }

  /**
   * 查询平台账户实时金额
   */
  baseAccountBalance (param) {
    const url = URL.ZBBank.baseAccountBalance
    return axios.post(url, param)
  }

  /**
   * 通过虚拟账户编码查询平台账户
   */
  queryPlatformAccountByExAccountNo (param) {
    const url = URL.ZBBank.queryPlatformAccountByExAccountNo
    return axios.post(url, param)
  }

  /**
   * 查询保证金账户
   */
  queryBZJAccount (param) {
    const url = URL.BZJAccount.queryBZJAccount
    return axios.post(url, param)
  }
  /**
   * 查询保证金账户资金流水
   */
  flowList (param) {
    const url = URL.BZJAccount.flowList
    return axios.post(url, param)
  }
  /**
   * 保证金提现
   */
  bzjCash (param) {
    const url = URL.BZJAccount.bzjCash
    return axios.post(url, param)
  }
}

export default new MyAccount()
